import { render } from "./paging.vue?vue&type=template&id=145e2cfe"
import script from "./paging.vue?vue&type=script&lang=js"
export * from "./paging.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__